<template>
    <section>
        <sy-baselist
                ref="main"
                hideAdd
                hideOperate
                :filters="filters"
                @beforeDelete="beforeDelete"
                editVue="system/User_Edit.vue"
                listUrl="server/system/User.ashx?cmd=GetUserList"
                deleteUrl="server/system/User.ashx?cmd=DeleteUser"
        >
            <el-table-column prop="FCode" label="登录名" width="150" >
            </el-table-column>
            <el-table-column prop="FName" label="用户名" width="250" >
            </el-table-column>
            <!-- <el-table-column prop="DeptName" label="管辖区域" width="200" sortable="custom">
            </el-table-column>  -->
            <!-- <el-table-column prop="RoleName" label="系统角色" width="150" sortable="custom">
            </el-table-column> -->
             <!-- <el-table-column prop="FIsManager" label="总部管理员" :formatter="formatIsManager" width="120" >
            </el-table-column> -->
        </sy-baselist>
    </section>
</template>

<script>
    import util from '../../common/util'
    export default {
        data(){
            return {
                filters: [
                    {type: "string",name:"FName",text:"用户名", value: ""}]
            }
        },
        methods:{
            formatIsManager(row){
                  return row.FIsManager==1?"是":"否"
            },
            beforeDelete(row,r){
                if(row.FID<0) {
                    return r.error = "系统用户，不能删除";
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/User.vue